import axios from "axios";

import { getToken } from "@/utils/tokenStorage";

const API = "/api";
const cfg = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

// {id, name, acao: "apagar"|"arquivar", motivo}
export const previaProduto = async (id) => (await axios.get(`${API}/products/${id}/exclusao`, cfg())).data;
// {acao: "apagado"|"arquivado", motivo}
export const excluirProduto = async (id) => (await axios.delete(`${API}/products/${id}`, cfg())).data;

// {categoria, produtos: [{id, name, acao, motivo}], arquivados}
export const previaCategoria = async (id) => (await axios.get(`${API}/categories/${id}/exclusao`, cfg())).data;
export const excluirCategoria = async (id, comProdutos) =>
  (await axios.delete(`${API}/categories/${id}`, { ...cfg(), params: comProdutos ? { com_produtos: true } : {} })).data;

/** Detail do FastAPI (string, ou lista do 422) → texto para o toast. */
export function mensagemDeErro(e, padrao) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg;
  return padrao;
}
